(() => {
  const balk = document.querySelector('[data-stickybuy]');
  if (!balk) return;

  const MEERDERE = balk.dataset.meerdere === 'true';
  const form = balk.querySelector('[data-sticky-form]');
  const tekst = balk.querySelector('[data-sticky-tekst]');
  const deKolom = () => document.querySelector('.vt-buy');

  if (tekst) {
    tekst.textContent = MEERDERE
      ? balk.dataset.kiesTekst || ''
      : balk.dataset.koopTekst || '';
  }
  balk.classList.toggle('is-kiezen', MEERDERE);

  const naarKiezer = (e) => {
    if (!MEERDERE) return;
    e.preventDefault();
    const doel =
      deKolom()?.querySelector('.vt-familie') ||
      deKolom()?.querySelector('variant-picker') ||
      deKolom()?.querySelector('[data-vt-lengte]') ||
      document.getElementById('vt-koop') ||
      deKolom();
    if (!doel) return;

    doel.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
      block: 'center',
    });

    doel.classList.add('is-gewezen');
    setTimeout(() => doel.classList.remove('is-gewezen'), 1400);
  };

  balk.querySelector('[data-sticky-kies]')?.addEventListener('click', naarKiezer);
  form?.addEventListener('submit', naarKiezer);

  const koopknop = document.querySelector('.vt-atc');
  if (!koopknop || !('IntersectionObserver' in window)) return;

  balk.hidden = false;
  new IntersectionObserver((rijen) => {
    for (const r of rijen) {
      if (r.isIntersecting) balk.removeAttribute('data-show');
      else if (r.boundingClientRect.top < 0) balk.setAttribute('data-show', '');
    }
  }, { threshold: 0 }).observe(koopknop);
})();
